import React from 'react'
import { Box, Text, Button, Flex} from '@mantine/core'
import classes from './DetailSlug.module.css'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { update } from '../../../../store/cartData'
import { useLocalStorage } from '@mantine/hooks'
import { useSelector } from 'react-redux'
import { formatPrice } from '../../../../plugins/formatPrice'

const defaultRoute = {
  key: 'route',
  defaultValue: ''
}


const TemplateSection = ({ schedules }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const params = useParams()
  const [, setRoute] = useLocalStorage(defaultRoute)
  const { isLogin } = useSelector(state => state.auth)

  const emptySchedules = () => {
    return (
      <Box p={16}>
        <Text align="center" fz="md" fw="bold">Belum ada template yang tersedia</Text>
      </Box>
    )
  }

  const listSchedules = () => {
    const dataSchedule = schedules[0]

    const handleCheckout = (scheduleId, schedulePrice) => {
      const data = {
        transactionMethodId: null,
        eventScheduleIds: [ scheduleId ],
        eventSlug: params.slug,
        totalPrice: schedulePrice
      }
      dispatch(update({ 'cart': data }))
      if (!isLogin) {
        navigate("/login")
        setRoute('/checkout')
      } else {
        navigate("/checkout")
      }
    }

    return (
      <Flex justify='flex-end'>
        <Box ta='right'>
          <Text className={classes.priceSection} fw="bold" c="red" mb={4}>{formatPrice(dataSchedule.price)}</Text>
          <Button radius="md" size='sm' onClick={() => handleCheckout(dataSchedule.id, dataSchedule.price)}>Beli Sekarang</Button>
        </Box>
      </Flex>
    )
  } 

  return (
    <Box mb={35}>
      <Box mt="md">
        {schedules.length > 0 ? listSchedules() : emptySchedules()}
      </Box>
    </Box>
  )
}

export default TemplateSection